function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M0 0H1440V1276H0z",
  transform: "translate(-790 -1003)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  d: "M0 0h210c3.314 0 6 2.686 6 6s-2.686 6-6 6H0V0z",
  transform: "translate(-790 -1003) translate(790 1003) translate(162 34)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M0 2h210c2.21 0 4 1.79 4 4s-1.79 4-4 4H0V2z",
  transform: "translate(-790 -1003) translate(790 1003) translate(162 34)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-790 -1003) translate(790 1003) translate(22 26)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M40 0H58V7H40z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M0 8L10 8 10 20 0 20zM12 6h10v16H12c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2zM31 6L68 6 68 22 31 22zM80 9L106 9 106 19 80 19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M82 11H104V15H82z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M109 6c-1.657 0-3 1.343-3 3v10c0 1.657 1.343 3 3 3s3-1.343 3-3V9c0-1.657-1.343-3-3-3z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 21,
  x: 85,
  y: 3,
  fill: "#5C8DF6",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 21,
  x: 91,
  y: 3,
  fill: "#5C8DF6",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 21,
  x: 97,
  y: 3,
  fill: "#5C8DF6",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M140 0c1.105 0 2 .895 2 2v24c0 1.105-.895 2-2 2s-2-.895-2-2V2c0-1.105.895-2 2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M33 8H66V12H33z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M31 0L22 0 22 28 31 28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M22 7H31V11H22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24 2H29V6H24zM12 8H18V12H12zM2 10H8V14H2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M22 17H31V21H22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M73 6h7v16h-7c-2.761 0-5-2.239-5-5v-6c0-2.761 2.239-5 5-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M75 8L78 8 78 12 75 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M112 9L120 9 120 19 112 19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M114 11L118 11 118 15 114 15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M126 7h-2c-2.21 0-4 1.79-4 4v6c0 2.21 1.79 4 4 4h2V7zM140 5h-10c-2.21 0-4 1.79-4 4v10c0 2.21 1.79 4 4 4h10V5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M130 7h8v4h-10V9c0-1.105.895-2 2-2zM109 8c.552 0 1 .448 1 1v5h-2V9c0-.552.448-1 1-1z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#BED1FB",
  transform: "translate(-790 -1003) translate(790 1003) translate(183 15)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 116.5,
  cy: 2.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175.5,
  cy: 36.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55.5,
  cy: 11.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 49,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 38,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 44.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 38.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 37,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 10,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 210,
  cy: 25,
  r: 1
}))));

var SvgPicLoaderLightsaber = function SvgPicLoaderLightsaber(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 80,
    viewBox: "0 0 400 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicLoaderLightsaber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pic-loader-lightsaber.383909a5.svg";
export { ForwardRef as ReactComponent };